import React from 'react';
import {editCompanyTextAction} from "../../../../../../../../services/company/api";
import {t} from "../../../../../../../../components/Translate";
import ChoiceButtons from "../../../../../../../../components-new/form/ChoiceButtons";
import SettingCard from "../../../../../../../../components-new/ui/SettingCard";

const TextActionSelector = ({features, client, user, textAction, setTextAction, isFetching}) => {

    const textActionOptions = [
        {
            label: t({text: "connectToOperator", user}),
            value: 'CONNECT_TO_OPERATOR'
        },
        {
            label: t({text: "sendIDontKnowText", user}),
            value: 'SEND_I_DONT_KNOW_TEXT'
        },
        {
            label: t({text: "nothingToDo", user}),
            value: 'NOTHING_TO_DO'
        }
    ];

    const handleChange = (value) => {
        setTextAction(value);
        editCompanyTextAction(client.id, value);
    };

    return (
        <SettingCard titleKey="chatbotActionsWhenUserTextIsUnknown">
            <div className="setting-body">
                <div className="setting-field">
                    <ChoiceButtons
                        value={textAction || 'CONNECT_TO_OPERATOR'}
                        options={textActionOptions}
                        onChange={handleChange}
                        disabled={isFetching}
                    />
                </div>
            </div>
        </SettingCard>
    );
};

export default TextActionSelector;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/functions/components/TextActionSelector.jsx